<script>
  import Link from '../../../utils/link';
  import Card from '../../../components/containers/card.html';
  import Avatar from '../../../components/containers/avatar.html';

  export let sponsor;

  function getSponsorLink() {
    return `/sponsors/view/${sponsor.id}`;
  }
</script>

<Card hover>
  <Link href={getSponsorLink()}>
    <div class="u--padall">
    <div class="grid-x grid-margin-x">
     <div class="cell small-12 text-center">
        <Avatar larger avatar={sponsor.logo} />
      </div>
      <div class="cell small-12 text-center">
        <div class="u--padall">
          <h3>
            {sponsor.name}
          </h3>
        </div>
      </div>
    </div>
  </div>
  </Link>
</Card>


